
import {toggleSlide} from './Util';

const initToggleNewsletterExpandableText = () => {
	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target && ev.target.closest( '.mdl_newsletterregister__info-trigger' ) ) {
			const triggerEl = ev.target;
			const containerEl = triggerEl.closest( '.mdl_newsletterregister' );
			const textEl = containerEl.querySelector( '.mdl_newsletterregister__expandable-info' );

			const shouldShow = ! triggerEl.classList.contains( 'is-visible' );

			// Toggle Display of text and trigger.
			triggerEl.classList.toggle( 'is-visible', shouldShow );
			triggerEl.ariaExpanded = shouldShow;
			textEl.ariaHidden = ! shouldShow;
			toggleSlide( textEl, shouldShow );
		}
	} );
};

export { initToggleNewsletterExpandableText };
